import EducationDegree from "./educationDegree"

export default EducationDegree